import styled from '@emotion/styled';
import {
  SidebarMenuItemBgColors,
  SidebarMenuItemTextColors,
  SidebarMenuItemVariant,
} from './sidebar-menu-item.constants';

export const SideBarMenuItemStyled = {
  Container: styled.div<any>`
    display: flex;
    height: 40px;
    align-items: center;
    margin-left: 20px;
    margin-right: 20px;
    border-radius: 5px;
    margin-top: 10px;
    background: ${(props: any) => {
      const variant: SidebarMenuItemVariant = props.variant;
      return SidebarMenuItemBgColors[variant]
    }};
    &:hover {
      cursor: pointer;
    }
  `,
};

export const sx = (variant: SidebarMenuItemVariant) => {
  return {
    TypographyMainText: {
      marginLeft: '10px',
      textAlign: 'justify',
      wordWrap: 'break-word',
      color: SidebarMenuItemTextColors[variant],
    },
  }
};
